import React, { useRef } from "react";
import { Form, Col, Button, Row } from "react-bootstrap";
import { BfButtonBlue, BfButtonBlueSecondary, StyledSelect } from "../../../Styling/styledForm/styledBlueForm";
import {
    StyledModal,
    StyledModalBody,
    StyledModalFooter,
} from "../../../Styling/styledModal/styledModals";
import DateTimePicker from '../../../components/dateTimePicker/DateTimePicker'
import Cleave from "cleave.js/react";
import _ from 'lodash'
import styled from 'styled-components';

const StyledCleave = styled(Cleave)`
  font-size: 20px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ccc;
`;


// Eksempel på file upload i react
// https://www.geeksforgeeks.org/file-uploading-in-react-js/

// Det finnes eksempler på hvordan man kan kommer rundt styling av knapp for upload

const Betaling01Modal = (props) => {

    const showRedBorder = (errorMessage => {      
        if (!errorMessage)
            return { display: 'inline-block' }

        return { border: '4px solid #cd4631', borderRadius: '10px', display: 'inline-block' }
    })

    const localeMessages =  props.funcs.localeMessages 
    
    let btnRef = useRef();
    
    const fakturaSelect = () => {

        console.log('Fakturaselect', props.funcs.fakturaListe)

        return (
            <>
                <StyledSelect className="form-control" name="faktura" value={props.funcs.fakturaId} onChange={props.funcs.onFakturaIdChange}>
                    <option value="">{localeMessages["BT1M_faktura"]}</option>
                    {props.funcs.fakturaListe.map((fakt, i) =>
                        <option key={fakt.invoiceNo} value={fakt.invoiceNo}>{fakt.invoiceNo} - {fakt.invoiceRegarding}</option>
                    )}
                </StyledSelect>
            </>
        )
    }


    return (

        <StyledModal centered show={true} onHide={props.funcs.cancelHandler}>

            <StyledModalBody>
                <h4>{localeMessages["BT1M_Overskrift"]}</h4>
                <Form.Group>

                    <Form.Label column="sm">
                        {localeMessages["BT1M_paymentDate"]}
                    </Form.Label>
                    <Col>
                        <div style={showRedBorder(props.funcs.paymentDateError)}>
                            
                            <DateTimePicker
                                selected={props.funcs.paymentDate}
                                onChange={props.funcs.handleChangePaymentDate}
                                dateFormat="dd.MM.yyyy"
                                timeCaption="time"                                               
                            />
                        </div>    
                    </Col>
                    {!props.funcs.validPaymentDate &&
                        <>
                            <Form.Label column="sm" lg={12} style={{color: '#cd4631', fontWeight: '800', fontSize: '19px'}}>
                            {props.funcs.paymentDateError}
                            </Form.Label>
                        </>
                    }                        

                    <Form.Label column="sm" lg={4}>
                        {localeMessages["BT1M_Belop"]}
                    </Form.Label>
                    <Col>                            
                        <StyledCleave placeholder="0,00"                               
                            onChange={props.funcs.onAmountChange}
                            value={props.funcs.amountString}
                            options={{
                                numeral: true,
                                numeralThousandsGroupStyle: 'thousand',
                                delimiter: ' ',
                                numeralDecimalMark: ','
                            }}

                        />

                    </Col>

                    <Form.Label column="sm" lg={4}>
                        {localeMessages["BT1M_valuta"]}
                    </Form.Label>
                    <Col>
                        {props.funcs.currency}
                    </Col>

                    <Form.Label column="sm" lg={4}>
                        {localeMessages["BT1M_faktura"]}
                    </Form.Label>
                    <Col>
                        {fakturaSelect()}
                    </Col>
                    

                </Form.Group>

            </StyledModalBody>

            <StyledModalFooter>
                <BfButtonBlue
                    ref={btnRef}
                    disabled={props.funcs.validates()}
                    onClick={props.funcs.okHandler}>
                    {localeMessages["BT1M_Ok"]}
                </BfButtonBlue>
                <BfButtonBlueSecondary textAsBorder blackBorder onClick={props.funcs.cancelHandler}>
                    {localeMessages["BT1M_Avbryt"]}
                </BfButtonBlueSecondary>

            </StyledModalFooter>

        </StyledModal>
    );
};

export default Betaling01Modal;